import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { authInterceptor } from './auth/auth.interceptor';
import { signupThrottleInterceptor } from './signup/intake/signup-throttle.interceptor';
import { FullstoryService } from './fullstory/fullstory.service';
import { AnonymousIdService } from './analytics/anonymous-id.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptors([authInterceptor, signupThrottleInterceptor])),
    provideAnimationsAsync(),
    provideAppInitializer(() => inject(FullstoryService).initialize()),
    provideAppInitializer(() => inject(AnonymousIdService).initialize()),
  ],
};
